"use client";

import React, { useEffect, useState } from "react";
import Link from "next/link";
import {
  FaFacebookF,
  FaInstagram,
  FaYoutube,
  FaLinkedinIn,
  FaPinterestP,
  FaEnvelope,
  FaPhone,
  FaMapMarkerAlt,
  FaBuilding,
  FaBrain,
  FaHandshake,
  FaStore,
  FaShoppingCart,
  FaUtensils,
  FaLeaf,
  FaWhatsapp,
  FaArrowUp,
  FaGlobe,
  FaBriefcase,
} from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";

export default function Footer() {
  const currentYear = new Date().getFullYear();
  const [showScroll, setShowScroll] = useState(false);
  const [loadMap, setLoadMap] = useState(false);

  useEffect(() => {
    let frameId: number | null = null;
    const checkScrollTop = () => {
      if (frameId !== null) return;

      frameId = requestAnimationFrame(() => {
        frameId = null;
        const scrollY = window.scrollY;
        if (!showScroll && scrollY > 400) {
          setShowScroll(true);
        } else if (showScroll && scrollY <= 400) {
          setShowScroll(false);
        }
      });
    };
    window.addEventListener("scroll", checkScrollTop, { passive: true });
    return () => {
      window.removeEventListener("scroll", checkScrollTop);
      if (frameId !== null) cancelAnimationFrame(frameId);
    };
  }, [showScroll]);

  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const socialLinks = [
    {
      name: "Facebook",
      href: "https://www.facebook.com/way2agribusiness",
      icon: FaFacebookF,
    },
    {
      name: "Twitter",
      href: "https://twitter.com/Way2agribusines",
      icon: FaXTwitter,
    },
    {
      name: "YouTube",
      href: "https://www.youtube.com/channel/UCEpkh59M-MDOj0TH6lxRpMg",
      icon: FaYoutube,
    },
    {
      name: "Instagram",
      href: "https://www.instagram.com/way2agribusiness/",
      icon: FaInstagram,
    },
    {
      name: "LinkedIn",
      href: "https://www.linkedin.com/feed/",
      icon: FaLinkedinIn,
    },
    {
      name: "Pinterest",
      href: "https://in.pinterest.com/Way2Agritech/_saved/",
      icon: FaPinterestP,
    },
  ];

  const serviceLinks = [
    {
      label: "way2agribusiness.com",
      url: "way2agribusiness.com",
      icon: FaBuilding,
    },
    { label: "way2agriintel.com", url: "way2agriintel.com", icon: FaBrain },
    {
      label: "way2agritech.com",
      url: "way2agritech.com",
      icon: FaShoppingCart,
    },
    { label: "way2foods.in", url: "way2foods.in", icon: FaUtensils },
    { label: "urbanagriculture.in", url: "urbanagriculture.in", icon: FaLeaf },
    { label: "farmneedz.com", url: "farmneedz.com", icon: FaBriefcase },

  ];

  const toolkitLinks = [
    { label: "Buyers Guidelines", href: "/tool-info/buyers-toolkit" },
    { label: "Vendors Guidelines", href: "/tool-info/vendor-toolkit" },
    { label: "User Guidelines", href: "/tool-info/user-guidelines" },
    { label: "Privacy Policy", href: "/tool-info/privacy-policy" },
  ];

  return (
    <footer className="bg-[#094721] text-white w-full pt-12 pb-6 border-t-4 border-green-700">
      <div className="mx-auto w-full max-w-[1800px] px-6 lg:px-16">

        {/* Top Header Section */}
        <div className="flex flex-col md:flex-row justify-between items-center mb-10 gap-6 border-b border-white/10 pb-6">
          <div className="text-xl lg:text-3xl  font-semibold font-[--font-mono]  text-white">
            KarnatakaAgribusiness
          </div>
          <div className="flex gap-3">
            {socialLinks.map((link) => {
              const IconComponent = link.icon;
              return (
                <a
                  key={link.name}
                  href={link.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-white/10 hover:bg-white text-[#094721] hover:text-[#094721] rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110 shadow-xs cursor-pointer"
                  aria-label={link.name}
                >
                  <IconComponent size={18} className="text-white hover:text-[#094721] transition-colors" />
                </a>
              );
            })}
          </div>
        </div>

        {/* Main Grid Content */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-12 gap-8 lg:gap-12 mb-12">

          {/* Column 1: OUR LOCATION */}
          <div className="sm:col-span-1 lg:col-span-4">
            <h3 className="text-xs lg:text-sm font-black mb-4  tracking-[0.2em] border-b border-white/15 pb-2">
              OUR LOCATION
            </h3>
            <div className="rounded-lg overflow-hidden mb-4 border border-white/10 shadow-md h-[120px] relative bg-slate-900 flex items-center justify-center">
              <iframe
                title="Way2Agribusiness Office Location on Google Maps"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3887.3103672988796!2d77.54279487373257!3d13.015896913908291!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae3d16cdf05995%3A0x3710354fdabf9e1b!2sWay2Agribusiness%20India%20Pvt%20LTD!5e0!3m2!1sen!2sin!4v1782463819130!5m2!1sen!2sin"
                width="100%"
                height="120"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="strict-origin-when-cross-origin"
              ></iframe>
            </div>
            <div className="flex gap-3 text-sm text-white/90 leading-relaxed">
              <FaMapMarkerAlt
                className="mt-1 flex-shrink-0 text-green-300"
                size={16}
              />
              <p className="text-xs lg:text-sm">
                Way2Agribusiness India Pvt. Ltd., ಕೃಷಿ ಮಿತ್ರ , #636, BDA
                Block 2, APMC (RMC) Yard, Yeshwanthpura, Bengaluru - 560022
              </p>
            </div>
          </div>

          {/* Column 2: CONTACT US */}
          <div className="sm:col-span-1 lg:col-span-3">
            <h3 className="text-xs lg:text-sm font-black mb-4  tracking-[0.2em] border-b border-white/15 pb-2">
              CONTACT US
            </h3>
            <div className="space-y-5">
              {/* Emails */}
              <div className="flex gap-3">
                <div className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center flex-shrink-0 shadow-inner">
                  <FaEnvelope size={16} className="text-green-300" />
                </div>
                <div className="text-xs lg:text-sm space-y-1 min-w-0">
                  <a
                    href="mailto:dr.prasannad@way2agribusiness.com"
                    className="block py-1 hover:text-green-300 transition-colors truncate"
                  >
                    dr.prasannad@way2agribusiness.com
                  </a>
                  <a
                    href="mailto:way2agribusiness@gmail.com"
                    className="block py-1 hover:text-green-300 transition-colors truncate"
                  >
                    way2agribusiness@gmail.com
                  </a>
                  <a
                    href="mailto:way2agritech@gmail.com"
                    className="block py-1 hover:text-green-300 transition-colors truncate"
                  >
                    way2agritech@gmail.com
                  </a>
                </div>
              </div>
              {/* Phones */}
              <div className="flex gap-3">
                <div className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center flex-shrink-0 shadow-inner">
                  <FaPhone size={16} className="text-green-300" />
                </div>
                <div className="text-xs lg:text-sm space-y-1">
                  <div className="flex items-center gap-2">
                    <span className="font-semibold">(+91) 9449004956</span>
                  </div>
                  <p className="font-semibold">(+91) 8277078435</p>
                  <p className="font-semibold">(+91) 8095000388</p>
                </div>
              </div>
            </div>
          </div>

          {/* Column 3: OUR SERVICES */}
          <div className="sm:col-span-1 lg:col-span-3">
            <h3 className="text-xs lg:text-sm font-black mb-4 tracking-[0.2em] border-b border-white/15 pb-2">
              OUR SERVICES
            </h3>
            <div className="flex flex-col gap-y-3">
              {serviceLinks.map((link) => {
                const IconComponent = link.icon;
                return (
                  <a
                    key={link.label}
                    href={`https://${link.url}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center gap-3 text-xs lg:text-sm hover:text-green-300 transition-colors group cursor-pointer"
                  >
                    <IconComponent
                      size={16}
                      className="text-white/70 group-hover:text-green-300 group-hover:scale-110 transition-all duration-200"
                    />
                    <span className="group-hover:translate-x-1 transition-transform duration-200">{link.label}</span>
                  </a>
                );
              })}
            </div>
          </div>

          {/* Column 4: TOOLKIT */}
          <div className="sm:col-span-1 lg:col-span-2">
            <h3 className="text-xs lg:text-sm font-black mb-4  tracking-[0.2em] border-b border-white/15 pb-2">
              TOOLKIT
            </h3>
            <div className="flex flex-col gap-y-3">
              {toolkitLinks.map((link) => (
                <Link
                  key={link.label}
                  href={link.href}
                  className="flex items-center gap-3 text-xs lg:text-sm hover:text-green-300 transition-colors group cursor-pointer"
                >
                  <span className="text-white/50 group-hover:text-green-300 group-hover:translate-x-0.5 transition-all duration-200 font-bold">
                    &gt;
                  </span>
                  <span className="group-hover:translate-x-1 transition-transform duration-200">{link.label}</span>
                </Link>
              ))}
            </div>
          </div>

        </div>

        {/* Bottom Bar */}
        <div className="pt-6 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4 text-[10px] lg:text-xs text-white/60  tracking-wider">
          <p>© {currentYear} Way2Agribusiness India Pvt Ltd.</p>
          <div className="flex items-center gap-6">
            <Link
              href="/tool-info/privacy-policy"
              className="hover:text-white transition-colors"
            >
              Privacy Policy
            </Link>
            <Link
              href="/tool-info/user-guidelines"
              className="hover:text-white transition-colors"
            >
              Terms of Service
            </Link>
          </div>
        </div>
      </div>

      {/* Scroll to Top Button */}
      <button
        onClick={scrollTop}
        className={`fixed bottom-6 right-6 w-10 h-10 bg-green-500 hover:bg-green-600 text-white rounded-full flex items-center justify-center shadow-lg transition-all duration-500 z-50 cursor-pointer hover:scale-105 active:scale-95 ${showScroll
          ? "opacity-100 translate-y-0"
          : "opacity-0 translate-y-10 pointer-events-none"
          }`}
        aria-label="Scroll to top"
      >
        <FaArrowUp size={16} />
      </button>
    </footer>
  );
}
